import { useForm } from "@inertiajs/react";
import { FormEvent, useContext, useState } from "react";

import SimpleButton from "@/components/Buttons/SimpleButton";
import { StatusType } from "@/components/Buttons/SimpleButton/types";
import TextFieldComponent from "@/components/TextField";
import Typography from "@/components/Typography";
import { AlertContext } from "@/contexts/Alert";

import { Access, Container, Form, Img, Infos } from "./styles";

interface InvitationProps {
  invitation_token?: string;
  name?: string;
}

export default function Invitation({ invitation_token, name = "" }: InvitationProps) {
  const { showAlert } = useContext<any>(AlertContext);
  const [buttonStatus, setButtonStatus] = useState<StatusType>("enable");

  const { data, setData, put } = useForm({
    name: name || "",
    password: "",
    password_confirmation: "",
    invitation_token: invitation_token || "",
  });

  const submitInvitation = (e: FormEvent) => {
    e.preventDefault();

    if (data.password !== data.password_confirmation) {
      showAlert({
        message: "As senhas não coincidem. Tente novamente.",
        type: "error",
      });
      return;
    }

    if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,}$/.test(data.password)) {
      showAlert({
        message:
          "A senha precisa ter no mínimo 8 caracteres, uma letra minúscula, uma maiúscula, um número e um símbolo especial.",
        type: "error",
      });
      return;
    }

    setButtonStatus("loading");
    put("/new_users/invitation", {
      onFinish: () => {
        setButtonStatus("enable");
      },
      onSuccess: () => {
        showAlert({
          message: "Convite aceito com sucesso! Você pode fazer login agora.",
          type: "success",
        });
      },
      onError: (errors: any) => {
        setButtonStatus("enable");
        const errorMessage = errors?.base || "Erro ao aceitar convite. Tente novamente.";
        showAlert({
          message: errorMessage,
          type: "error",
        });
      },
    });
  };

  return (
    <Container>
      <div className="grid h-full grid-cols-1 justify-between gap-2 lg:grid-cols-2">
        <Infos className="col-span-1 grid grid-cols-1">
          <div className="flex flex-col items-center justify-center">
            <div className="mx-auto px-12">
              <img src="/geedee.svg" alt="logo" className="h-20 w-52" />
            </div>
            <Access className="col-span-2 mx-auto max-w-md pt-8">
              <Form onSubmit={submitInvitation} className="w-full">
                <div className="mx-auto flex flex-col pb-10">
                  <Typography variant="h3" color="grey800" className="mx-auto">
                    Aceitar Convite
                  </Typography>
                  <Typography variant="pLarge" color="grey500" className="mx-auto pt-1 text-center">
                    Configure sua senha para completar o seu cadastro de investidor.
                  </Typography>
                </div>

                <div className="forms-input">
                  <div className="input">
                    <TextFieldComponent
                      disabled={false}
                      label="Seu nome completo"
                      error={false}
                      required
                      type="text"
                      autoComplete="off"
                      readOnly
                      onFocus={(e) => (e.target.readOnly = false)}
                      value={data.name}
                      onChange={(e) => setData("name", e.target.value)}
                    />
                  </div>

                  <div className="input">
                    <TextFieldComponent
                      disabled={false}
                      label="Sua senha"
                      error={false}
                      password={true}
                      autoComplete="off"
                      readOnly
                      onFocus={(e) => (e.target.readOnly = false)}
                      value={data.password}
                      required
                      onChange={(e) => setData("password", e.target.value)}
                    />
                  </div>

                  <div className="input">
                    <TextFieldComponent
                      disabled={false}
                      label="Confirmar sua senha"
                      error={false}
                      password={true}
                      autoComplete="off"
                      readOnly
                      onFocus={(e) => (e.target.readOnly = false)}
                      value={data.password_confirmation}
                      required
                      onChange={(e) => setData("password_confirmation", e.target.value)}
                    />
                  </div>
                </div>

                <div className="pt-8">
                  <SimpleButton variant="cta" status={buttonStatus} label="Aceitar Convite" />
                </div>
              </Form>
            </Access>
          </div>
        </Infos>

        <Img className="invisible w-full lg:visible">
          <div className="image w-full" />
        </Img>
      </div>
    </Container>
  );
}
